import React from "react";
import BracketButton from "../../bracketButton/bracketButton";
import { getRouteUrl } from "../../../routers";
import { ROUTE_APPLICATION_GO_LIVE } from "../../../routers/content/application";

const GoLive = (props) => {
  const { applicationId, organizationUuid } = props;

  // Certificate validation is now handled by the backend during GoLive creation
  // We can navigate directly to the GoLive form
  const goLiveUrl = getRouteUrl(
    ROUTE_APPLICATION_GO_LIVE,
    { applicationId: applicationId },
    { organization: organizationUuid }
  );

  return (
    <BracketButton
      movingBrackets
      testId="go-live-button"
      title="Go live"
      url={goLiveUrl}
    />
  );
};

export default GoLive;
